export default __webpack_public_path__ + "static/media/1297.f96ad92f.png";